export const getters = {
  systemConsignees: state => state.consignees
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/consignees/getters.js